import * as ReactDOMClient from 'react-dom/client';
import * as React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { CanvasProvider } from '@workday/canvas-kit-react/common';
import { i18next } from './i18n';
import { store } from './js/store';
import { App } from './App';
import { BrowserRouter } from 'react-router-dom';
import { WclDevTools } from './js/wcl-dev-tools/wcl-dev-tools';

// only bundled in development builds
const DevTools = process.env.NODE_ENV === 'development' ? WclDevTools : ({ children }) => children;

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = ReactDOMClient.createRoot(rootElement);
    root.render(
        <BrowserRouter>
            <React.StrictMode>
                <Provider store={store}>
                    <I18nextProvider i18n={i18next}>
                        <CanvasProvider>
                            <DevTools>
                                <App />
                            </DevTools>
                        </CanvasProvider>
                    </I18nextProvider>
                </Provider>
            </React.StrictMode>
        </BrowserRouter>
    );
}
